export default __webpack_public_path__ + "static/media/menu-clients.8b5838b6.svg";